import { render, staticRenderFns } from "./pages-body.vue?vue&type=template&id=5b3a989b"
import script from "./pages-body.vue?vue&type=script&lang=js"
export * from "./pages-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports